export default __webpack_public_path__ + "static/banner-mobile-proviotics-1-b30c352e5ab7262cf88d0f8edbe626c1.png";